"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugsnagStream = exports.bugsnag = exports.haveBugsnag = void 0;
const js_1 = require("@bugsnag/js");
const stream_1 = require("stream");
const lodash_1 = require("lodash");
exports.haveBugsnag = process.env.NODE_ENV !== "test" && process.env.BUGSNAG_API_KEY !== undefined && process.env.SKIP_BUGSNAG !== "true";
function getBugSnag() {
    if (exports.haveBugsnag) {
        return (0, js_1.default)({
            apiKey: process.env.BUGSNAG_API_KEY,
        });
    }
}
const initializeBugSnag = (0, lodash_1.once)(getBugSnag);
exports.bugsnag = initializeBugSnag();
class BugsnagStream extends stream_1.Writable {
    write(chunk, _) {
        const data = typeof chunk === "string" ? JSON.parse(chunk) : chunk;
        let callback;
        if (exports.bugsnag && data.err) {
            if (data.err.silenceBugsnag) {
                callback = (report) => report.ignore();
            }
            else if (data.err.code && data.err.code !== "UNKNOWN_ERROR") {
                callback = (report) => {
                    report.groupingHash = data.err.subcode ? `${data.err.code}-${data.err.subcode}` : data.err.code;
                };
            }
            exports.bugsnag.notify(data.err, {
                metaData: {
                    payload: data.err.payload,
                    functionName: data.err.functionName,
                },
                beforeSend: callback,
            });
        }
        return true;
    }
}
exports.BugsnagStream = BugsnagStream;
//# sourceMappingURL=BugsnagClient.js.map